<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, '思源黑体', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner{
  background-color: #01b983 !important;
  color:#fff !important
}
.el-submenu__title i{
  color:#fff !important
}
.el-tabs__content{
  display: none !important;
}
.el-notification{
  left: 0;
  right:0;
  margin:auto;
}
.errorType{
  font-size:20px !important;
  top:55% !important;
}
.errorType .el-message__content{

  font-size: 22px;
}
.el-notification{
  align-items: center;
  width: 490px !important;
}
.el-notification .el-notification__icon{
  font-size: 26px !important;
}
.el-notification .el-notification__closeBtn{
  font-size: 20px !important;
}
.el-notification .el-notification__title{
  font-size: 26px !important;
  
}
.el-checkbox__inner{
  border: 2px solid red !important;
  height:16px  !important;
  width:16px !important;
}
.el-checkbox__label{
  color: red;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
  border: 2px solid #409EFF !important;
}
input::placeholder,textarea::placeholder {
  font-size: 16px; /* 设置字体大小 */
  font-family: 'sans-serif', '思源黑体'; /* 设置字体类型 */
  color: #909090; /* 设置字体颜色 */
  opacity: 1; /* 设置透明度 */
}
@media screen and (max-width: 540px){
  .el-button{
    padding:8px 16px;
  }
  .activityList .cardItem{
    padding: 12px;
  }
}
</style>
